import { weekDay } from './DayEnToFr';

export const formatBestOfBostApi = (bestOfPosts: any) => {
  let newBestOfPosts: { [key:string]: any[] } = {
    saturday: [],
    sunday: [],
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
  };

  const setNewBestOfPosts = (object: any) => {
    newBestOfPosts = object;
  }

  const addPostBestOfByDay = (day: any, post: any) => {
    day = day.toLowerCase();
    let array = newBestOfPosts[day].filter((postDay) => postDay === post);
    if (array.length === 0) {
      setNewBestOfPosts({ ...newBestOfPosts, [day]: [...newBestOfPosts[day], post] });
    }
  };

  for (let i = 0; i < weekDay.length; i++) {
    for (let j = 0; j < bestOfPosts[weekDay[i]].length; j++) {
      let newData = {
        // id: bestOfPosts[weekDay[i]][j].id,
        slug: bestOfPosts[weekDay[i]][j].slug,
      };
      addPostBestOfByDay(weekDay[i], newData);
    }
  }
  return (newBestOfPosts);
}

export const formatArrayPost = (array: any[]) => {
  console.log("Cover Page: ", array)
  // const newTab = array.map(({slug, id}) => ({slug, id}));
  const newTab = array.map(({slug}) => ({slug}));
  return (newTab);
}

export const formatFieldsFromStrapi = (data: any) =>  {
  // title,id,slug,published_at,feature_image
  let newData
  newData = {
    title: data.title,
    slug: data.slug,
    feature_image: (data.image && data.image.length > 0) ? data.image[0].url : 'https://static.ghost.org/v3.0.0/images/welcome-to-ghost.png',
    published_at: data.publish_date,
  };
  return (newData);
}

export const formatArrayFieldsFromStrapi = (array: any[]) =>  {
  let newArray = [];
  // title,id,slug,published_at,feature_image
  for (let j = 0; j < array.length; j++) {
    let data = array[j].data
    newArray.push(formatFieldsFromStrapi(data));
  }
  return (newArray);
}